import { reatomAsync, withAbort } from "@reatom/async";
import { atom, withDataAtom } from "@reatom/framework";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export interface ProductSampleOption {
  label: string;
  value: number;
}

export const productSamplesOptionsAtom = atom((ctx) => {
  const samples = ctx.spy(getProductSamplesRequest.dataAtom);

  if (!samples.length || !samples) return [];

  return samples.map((sample) => ({
    label: sample.name,
    value: sample.id,
  }));
}, "productSamplesOptionsAtom");

export const getProductSamplesRequest = reatomAsync(async (ctx) => {
  return API.productSamplesApi
    .productSelectionControllerGetAll({
      signal: ctx.controller.signal,
    })
    .then((response) => response.data);
}, "getProductSamplesRequest").pipe(
  withDataAtom([]),
  withAbort(),
  withIsLoadingAtom(),
);
